import { duration } from '@material-ui/core';

const dialog_transition_duration =
  process.env.NODE_ENV === 'development'
    ? 0
    : { enter: duration.enteringScreen, exit: duration.leavingScreen };

export { dialog_transition_duration };
